// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e22634db","703":"6c8c1983","787":"afa1f1bd"}[chunkId] + ".chunk.js";
};